/* eslint-disable no-unused-vars */
import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import EditCoursesComponent from "../components/Courses/editcourse.component.vue";
import PreviewForumComponent from "../components/Forum/previewforum.component.vue";
import PreviewNewCourseComponent from "../components/Courses/PreviewNewCourse.component.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/DashbaordLayout",
    component: () =>
      import("../views/Layout/DashboardLayout/DashbaordLayout.vue"),
    redirect: "dashboard",
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("../views/Dashboard/Dashboard.vue"),
      },
      {
        path: "/team",
        name: "team",
        component: () => import("../views/Team/Team.vue"),
      },

      {
        path: "/team/profile",
        name: "profile ",
        component: () => import("../views/Team/ProfileView.vue"),
      },

      {
        path: "/Videos",
        name: "videos",
        component: () => import("../views/Videos/Video.vue"),
      },
      {
        path: "/blog",
        name: "blog",
        component: () => import("../views/Blog/Blog.vue"),
      },
      {
        path: "/blog/newarticle",
        name: "newartical",
        component: () => import("../views/Blog/newartical.vue"),
      },
      {
        path: "/blog/editarticle",
        name: "editarticle",
        component: () => import("../views/Blog/editartical.vue"),
      },
      {
        path: "/Testimonials",
        name: "testimonials",
        component: () => import("../views/Testimonials/Testimonials.vue"),
      },
      {
        path: "/users",
        name: "users",
        component: () => import("../views/Users/Users.vue"),
      },
      {
        path: "/users/profile/:id",
        name: "profile",
        component: () => import("../views/Users/userProfileview.vue"),
      },
      {
        path: "/users/userorder",
        name: "userorder",
        component: () => import("../views/Users/userorder.vue"),
      },

      {
        path: "/practitioners",
        name: "practitioners",
        component: () => import("../views/Practitioners/Practitioners.vue"),
      },
      {
        path: "/practitioners/practionerprofile",
        name: "practitioner",
        component: () => import("../views/Practitioners/practionerprofile.vue"),
      },
      {
        path: "/Courses",
        name: "courses",
        component: () => import("../views/Courses/Course.vue"),
      },
      {
        path: "/royaltycourses",
        name: "royaltycourses",
        component: () => import("../views/Courses/Royaltypagecourse.vue"),
      },
      {
        path: "/Seminars",
        name: "seminars",
        component: () => import("../views/Seminars/Seminars.vue"),
      },
      {
        path: "/Downloads",
        name: "downloads",
        component: () => import("../views/Downloads/Download.vue"),
      },
      {
        path: "/DigitalManual",
        name: "DigitalManual",
        component: () => import("../views/DigitalManual/DigitalManual.vue"),
      },
      {
        path: "/DigitalManual/Archived",
        component: () =>
          import("../views/DigitalManual/ArchivedDigitalManual.vue"),
      },
      {
        path: "/DigitalManual/version",
        component: () =>
          import("../views/DigitalManual/versionsManuals.vue"),
      },
    
      {
        path: "/Forum",
        name: "forum",
        component: () => import("../views/Forum/Forum.vue"),
      },
      {
        path: "/ForumPreview",
        name: "ForumPreview",
        component: PreviewForumComponent,
      },
      {
        path: "/Orders",
        name: "orders",
        component: () => import("../views/Sales/Sales.vue"),
      },
      {
        path: "/sales/salesorder",
        name: "salesorder",
        component: () => import("../views/Sales/salesorder.vue"),
      },
      {
        path: "/sales/archived",
        name: "archived",
        component: () => import("../views/Sales/archivedview.vue"),
      },
      // {
      //   path: "/MemberShip",
      //   name: "membership",
      //   component: () => import("../views/Membership/Membership.vue"),
      // },
      {
        path: "/Announcements",
        name: "announcements",
        component: () => import("../views/Announcements/Announcements.vue"),
      },
      {
        path: "/Store",
        name: "store",
        component: () => import("../views/Store/Store.vue"),
      },
      {
        path: "/Ads",
        name: "ads",
        component: () => import("../views/Ads/Ads.vue"),
      },
      {
        path: "/studygroupsandevents",
        name: "eventandstudy",
        component: () => import("../views/EventAndGroup/EventAndGroup.vue"),
      },
      // {
      //   path: "/WebEditer",
      //   name: "webediter",
      //   component: () => import("../views/WebEdit/WebEdit.vue"),
      // },
      {
        path: "/HelpCenter",
        name: "helpcenter",
        component: () => import("../views/HelpCenter/HelpCenter.vue"),
      },
      {
        path: "/HelpCenter/EditTopic",
        name: "editHelptopic",
        component: () => import("../views/HelpCenter/editHelpcenter.vue"),
      },
      {
        path: "/HelpCenter/NewTopic",
        name: "newtopic",
        component: () => import("../views/HelpCenter/addnewhelpcenter.vue"),
      },
      {
        path: "/setting",
        name: "setting",
        component: () => import("../views/Setting/Setting.vue"),
      },
      // {
      //   path: "/coordinator",
      //   name: "coordinator ",
      //   component: () => import("../views/Coordinators/Coordinators.vue"),
      // },
      {
        path: "/newsletter",
        name: "newsletter ",
        component: () => import("../views/NewsLetters/NewsLetters.vue"),
      },
      {
        path: "/polls",
        name: "polls ",
        component: () => import("../views/Polls/Polls.vue"),
      },
      {
        path: "/report",
        name: "report",
        component: () => import("../views/Polls/Report.vue"),
      }, 
        {
        path: "/preview",
        name: "preview",
        component: () => import("../views/Polls/previewpage.vue"),
      },
      {
        path: "/editpoll",
        name: "editpoll",
        component: () => import("../views/Polls/editpoll.vue"),
      },

      {
        path: "/hardship",
        name: "hardship ",
        component: () =>
          import("../views/Hradshipapplication/hardshipapplication.vue"),
      },
      {
        path: "/instructorusers",
        name: "instructorusers ",
        component: () =>
          import("../views/Instructorapplication/InstructorApplication.vue"),
      },
      {
        path: "/previewpolls",
        name: "previewpolls ",
        component: () => import("../views/Polls/PreviewPoll.vue"),
      },
      {
        path: "/createpolls",
        name: "createpolls ",
        component: () => import("../views/Polls/CreateNewPoll.vue"),
      },
      {
        path: "/adminrole",
        name: "adminrole ",
        component: () => import("../views/Roles/AdminRole.vue"),
      },
      {
        path: "/userrole",
        name: "userrole ",
        component: () => import("../views/Roles/UserRole.vue"),
      },
      // {
      //   path: "/shipping",
      //   name: "shipping ",
      //   component: () => import("../views/Shipping/Shipping.vue"),
      // },
      {
        path: "/coupon",
        name: "coupon ",
        component: () => import("../views/Coupon/Coupon.vue"),
      },
      {
        path: "/newcourse",
        name: "newcourse ",
        component: () => import("../views/Courses/AddNewCourses.vue"),
      },
      {
        path: "/newparamacourse",
        name: "newparamacourse ",
        component: () => import("../views/Courses/AddNewParamaCourses.vue"),
      },
      {
        path: "/newparamabundle",
        name: "newparamabundle ",
        component: () => import("../views/Courses/AddNewParamaBundle.vue"),
      },
      {
        path: "/seminarstudent/:id",
        name: "seminarstudent ",
        component: () => import("../views/SeminarStudent/SeminarStudent.vue"),
      },
      {
        path: '/editCourse/:id',
        name: "editcourse",
        component: () => import("../views/Courses/Editcourses.vue"),
      },
      
      // {
      //   path: "/editcourse",
      //   name: "editcourse ",
      //   component: EditCoursesComponent,
      // },
      {
        path: "/seecourse/:id",
        name: "seecourse ",
        //component: PreviewNewCourseComponent,
        component: () => import("../views/Courses/seecourses.vue"),
      },
      {
        path: "/seeparamacourses",
        name: "seeparamacourses ",
        component: () =>
          import("../components/Courses/previewparamacourses.vue"),
      },
      {
        path: "/editparamacourse",
        name: "editparamacourse ",
        component: () =>
          import("../components/Courses/NewParamaCouse/editparamacourses.vue"),
      },
      {
        path: "/editparamabundle",
        name: "editparamabundle ",
        component: () =>
          import("../components/Courses/NewParamaBundle/editParambundle.vue"),
      },
    ],
  },

  {
    path: "/",
    component: () => import("../views/Layout/AuthLayout/AuthLayout.vue"),
    redirect: "/login",
    children: [
      {
        path: "/login",
        name: "login",
        component: () => import("../views/Auth/Login/login.vue"),
      },
      {
        path: "/register/:id",
        name: "register",
        component: () => import("../views/Auth/Register/register.vue"),
      },
      {
        path: "/forgetpassword",
        name: "forgetpassword",
        component: () =>
          import("../views/Auth/ForgetPassword/ForgetPassword.vue"),
      },
      {
        path: "/forgetpassword2",
        name: "forgetpassword2",
        component: () =>
          import("../views/Auth/ForgetPassword/ForgetPasswordTwo.vue"),
      },
      {
        path: "/successfulScreen",
        name: "successfulScreen",
        component: () =>
          import("../views/Auth/ForgetPassword/successfulScreen.vue"),
      },
    ],
  },

  // 404 page -----------------------------
  {
    path: "*",
    name: "errorpage",
    component: () => import("../views/ErrorPage404/errorpage.vue"),
  },

  ////////////////////////////////////////// Graducation Templete
  {
    path: "/accessgraduation",
    name: "accessgraduation",
    component: () =>
      import("../components/GraduationTemplate/AccessGraduation.vue"),
  },
  {
    path: "/advancegraduation",
    name: "advancegraduation",
    component: () =>
      import("../components/GraduationTemplate/AdvanceGraduation.vue"),
  },
  {
    path: "/breakthroughgraduation",
    name: "BreakThroughGraduation",
    component: () =>
      import("../components/GraduationTemplate/BreakThroughGraduation.vue"),
  },
  {
    path: "/freefallgraduation",
    name: "FreeFallGraduation",
    component: () =>
      import("../components/GraduationTemplate/FreeFallGraduation.vue"),
  },
  {
    path: "/fundamentalgraduation",
    name: "FundamentalGraduation",
    component: () =>
      import("../components/GraduationTemplate/FundamentalGraduation.vue"),
  },
  {
    path: "/generalgraduation",
    name: "GeneralGraduation",
    component: () =>
      import("../components/GraduationTemplate/GeneralGraduation.vue"),
  },
  {
    path: "/mindscapegraduation",
    name: "MindScapeGraduation",
    component: () =>
      import("../components/GraduationTemplate/MindScapeGraduation.vue"),
  },

  // {
  //   path: "team",
  //   name: "team",
  //   component: () => import("../views/Team/Team.vue"),
  //   children:[
  //     {
  //       path:"/profile",
  //       name: "profile ",
  //       component:()=>import("../views/Team/ProfileView.vue") ,
  //     }
  //   ]
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (store.getters["isLoggedIn"]) { 
    if (to.name != "dashboard") {
      if (to.name != "login" && to.name != "register") {
        next();
      } else {
        next({ name: "dashboard" });
      }
    } else {
      next();
    }
  } else { 
    if (to.name == "login") {
      next();
    } else if (to.name == "register") {
      next();
    } else if (to.name == "forgetpassword") {
      next();
    } else if (to.name == "forgetpassword2") {
      next();
    } else {
      next({ name: "login" });
    }
  }
});

export default router;
